import { memo } from 'react';
import { SubscriptionProductItem } from '../../../utils/subscriptionDetail/types';
import styles from '../../../assets/scss/SubscriptionDetail/NextDeliverySubscription/SubscriptionProduct.module.scss';

type Props = {
  column: number;
  product: SubscriptionProductItem;
  onClickProductLink: (p: SubscriptionProductItem) => void;
};

export const StaticSubscriptionProduct = memo(function StaticSubscriptionProduct({
  column,
  product,
  onClickProductLink,
}: Props) {
  const {
    variantImage,
    title,
    discountRate,
    discountPercent,
    currentPriceAmount,
    category,
    shortName,
  } = product;

  const onClick = () => onClickProductLink(product);

  if (column === 1) {
    return (
      <>
        <div className={styles.card}>
          <Image variantImage={variantImage} />

          <div className={styles.info}>
            <Title
              column={column}
              title={title}
            />
            <PriceBox
              discountRate={discountRate}
              discountPercent={discountPercent}
              currentPriceAmount={currentPriceAmount}
            />
          </div>
        </div>

        <ProductLink onClick={onClick} />
      </>
    );
  }

  return (
    <>
      <Image variantImage={variantImage} />

      <Title
        column={column}
        title={title}
        categoryName={category}
        shortName={shortName}
      />

      <ProductLink onClick={onClick} />

      <PriceBox
        discountRate={discountRate}
        discountPercent={discountPercent}
        currentPriceAmount={currentPriceAmount}
      />
    </>
  );
});

type ImageProps = {
  variantImage: string;
};

function Image({ variantImage }: ImageProps) {
  return (
    <img
      className={styles.image}
      src={variantImage}
      alt=""
      loading="lazy"
    />
  );
}

type TitleProps = {
  column: number;
  title: string;
  categoryName?: string | undefined;
  shortName?: string | undefined;
};

function Title({ column, title, categoryName, shortName }: TitleProps) {
  if (column === 2 && categoryName && shortName) {
    return (
      <div className={styles.titles}>
        <p className={styles.category}>{categoryName}</p>
        <p className={styles.title}>{shortName}</p>
      </div>
    );
  }

  return (
    <div className={styles.titles}>
      <p className={styles.title}>{title}</p>
    </div>
  );
}

type PriceBoxProps = {
  discountRate: string | undefined;
  discountPercent: number;
  currentPriceAmount: number;
};

/** discountRate … 商品メタの HTML（優先）。無い／空なら discountPercent（計算値）を表示 */
function PriceBox({ discountRate, discountPercent, currentPriceAmount }: PriceBoxProps) {
  const colorClass = discountPercent > 10 ? styles.red : '';
  // 空白のみのメタは truthy になり得るため、trim してから HTML 表示するか決める
  const htmlDiscount = discountRate?.trim();

  return (
    <div className={styles.priceBox}>
      {htmlDiscount ? (
        <div
          className={styles.percent}
          dangerouslySetInnerHTML={{ __html: htmlDiscount }}
        />
      ) : (
        <p className={`${styles.percent} ${colorClass}`}>{' ' + discountPercent}%OFF</p>
      )}
      <div className={`${styles.price} ${colorClass}`}>
        <span className={styles.currency}>¥</span>
        <span className={styles.amount}>{currentPriceAmount.toLocaleString()}</span>
      </div>
    </div>
  );
}

type ProductLinkProps = {
  onClick: () => void;
};

function ProductLink({ onClick }: ProductLinkProps) {
  return (
    <p
      className={styles.productLink}
      onClick={onClick}
    >
      詳細を見る
    </p>
  );
}
